import { render, staticRenderFns } from "./StatisticProjectReportsBlankTable.vue?vue&type=template&id=708e4a86&scoped=true&"
import script from "./StatisticProjectReportsBlankTable.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlankTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsBlankTable.vue?vue&type=style&index=0&id=708e4a86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e4a86",
  null
  
)

export default component.exports